import { Text } from '@chakra-ui/react';
import type { Msg } from '@halo/chat-sdk-react';
import { MyTrans } from '@halo/ui-react';
import { useUserInfo } from '@/scripts/hooks';
import { MsgUserText } from '../../msg-parts';

export interface MsgGroupUpdateDescriptionContentProps {
  message: Msg;
}

export const MsgGroupUpdateDescriptionContent = memo(function MsgGroupUpdateDescriptionContent({
  message,
}: MsgGroupUpdateDescriptionContentProps) {
  const { t } = useTranslation();
  const { description, operator_user_id } = message.payload;

  const { user: operatorUser } = useUserInfo(operator_user_id);

  const formattedDescription =
    description && description.length > 40 ? `${description.slice(0, 40)}...` : description;

  return (
    <MyTrans
      i18nKey={
        description
          ? t('chat.groupMessageUpdateDescriptionText')
          : t('chat.groupMessageUpdateDescriptionClearedText')
      }
      components={{
        actionUser: <MsgUserText userName={operatorUser?.name || ''} userId={operator_user_id} />,
        action: <Text as="span" color="fg.muted" />,
        description: <Text as="span" color="fg.muted" />,
      }}
      values={{
        value: `'${formattedDescription}'`,
      }}
    ></MyTrans>
  );
});
